/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProviderKycData
 */
export interface ProviderKycData {
    /**
     * Link to the document directly on the provider.
     * @type {string}
     * @memberof ProviderKycData
     */
    statusLink: string;
    /**
     * Compliance state for this provider.
     * @type {boolean}
     * @memberof ProviderKycData
     */
    isCompliant: boolean;
    /**
     * Download links for documents on the provider side.
     * @type {Array<string>}
     * @memberof ProviderKycData
     */
    downloadLinks?: Array<string>;
}

/**
 * Check if a given object implements the ProviderKycData interface.
 */
export function instanceOfProviderKycData(value: object): value is ProviderKycData {
    if (!('statusLink' in value) || value['statusLink'] === undefined) return false;
    if (!('isCompliant' in value) || value['isCompliant'] === undefined) return false;
    return true;
}

export function ProviderKycDataFromJSON(json: any): ProviderKycData {
    return ProviderKycDataFromJSONTyped(json, false);
}

export function ProviderKycDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProviderKycData {
    if (json == null) {
        return json;
    }
    return {
        
        'statusLink': json['statusLink'],
        'isCompliant': json['isCompliant'],
        'downloadLinks': json['downloadLinks'] == null ? undefined : json['downloadLinks'],
    };
}

export function ProviderKycDataToJSON(value?: ProviderKycData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'statusLink': value['statusLink'],
        'isCompliant': value['isCompliant'],
        'downloadLinks': value['downloadLinks'],
    };
}

